import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Select,
  DatePicker,
  Switch,
  Input,
  Tag,
  Radio,
  Tooltip,
} from "antd";
import {
  VideoCameraOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import ModelWrapper from "../../../modal/ModelWrapper";
import { CustomButton, CustomSecondaryButton } from "../styled";
import { capitalizeFirstLetter } from "../../../../utils/utils";
import { formatDuration } from "../../../../utils/utils";
import AddPatientModal from "../../patients_page/AddPatientModal";
import videoService from "../../../../services/videos";
import { patientService } from "../../../../services/user";

const { Option } = Select;

const ScheduleEmailModal = ({
  isOpen,
  setIsOpen,
  selectedPatientForSchedule,
  setSelectedPatientForSchedule,
  selectedVideoForSchedule,
  setSelectedVideoForSchedule,
  scheduleDate,
  setScheduleDate,
  scheduleFrequency,
  setScheduleFrequency,
  repeatUntil,
  setRepeatUntil,
  enableFrequency,
  setEnableFrequency,
  customFrequencyNumber,
  setCustomFrequencyNumber,
  isCustomFrequency,
  setIsCustomFrequency,
  isLoading,
  setIsLoading,
  // videos,
  // patients,
  schedulePatientEmail,
  patientEditable,
  setPatientEditable,
  notificationType,
  setNotificationType,
  physicianList,
  userDetails,
  fetchPatient,
  userData,
}) => {
  const [addPatientModalOpen, setAddPatientModalOpen] = React.useState(false);
  const [newlyCreatedPatientId, setNewlyCreatedPatientId] =
    React.useState(null);
  // const [isLoading, setIsLoading] = useState(false);
  const [videos, setVideos] = useState([]);
  const [patients, setPatients] = useState([]);

  const handlePatientCreated = async (newPatientId) => {
    if (newPatientId) {
      setNewlyCreatedPatientId(newPatientId);
      // Auto-select the newly created patient
      if (Array.isArray(selectedPatientForSchedule)) {
        setSelectedPatientForSchedule([
          ...selectedPatientForSchedule,
          newPatientId,
        ]);
      } else {
        setSelectedPatientForSchedule([newPatientId]);
      }
    }
  };

  const handleModalClose = () => {
    setIsOpen(false);
    setSelectedPatientForSchedule([]);
    setSelectedVideoForSchedule([]);
    setScheduleDate(null);
    setScheduleFrequency(null);
    setRepeatUntil(null);
    setIsCustomFrequency(false);
    setCustomFrequencyNumber(1);
    setPatientEditable(false);
  };

  const getAllVideos = async () => {
    try {
      // console.log("getAllVideos");
      setIsLoading(true);

      const response = await videoService.getVideos(
        0,
        1,
        "",
        "",
        "",
        "",
        "",
        ""
      );
      // console.log("videodata", response?.data);
      setVideos(response?.data?.videos || []);
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPatients = async () => {
    try {
      setIsLoading(true);
      const response = await patientService.getAll(0, 1, "", "");

      // console.log("patientdata", response?.data?.results);
      setPatients(response?.data?.results || []);
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getAllVideos();
      fetchPatients();
    }
  }, [isOpen]);

  return (
    <ModelWrapper
      title={
        <div className="row-flex flex-column">
          <h3 className="font-18 font-semibold text-primary mb-5">
            Schedule Video
          </h3>
          <p className="font-14 text-secondry mb-0">
            Select a video and schedule when to send it to the patient
          </p>
        </div>
      }
      footer={null}
      show={isOpen}
      setShow={handleModalClose}
      width={650}
      keyClose={false}
      className="custom-detail-modal"
      bodyStyle={{
        maxHeight: "80vh",
        overflow: "auto",
        padding: "20px",
      }}
    >
      <Row gutter={[24, 24]}>
        {patientEditable && (
          <Col span={24}>
            <div
              className="font-medium mb-12"
              style={{ color: "var(--primary-text-color)" }}
            >
              Select Patients <span style={{ color: "#ff4d4f" }}>*</span>
            </div>
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              maxTagCount="responsive"
              placeholder="Choose patients"
              value={selectedPatientForSchedule}
              onChange={setSelectedPatientForSchedule}
              size="large"
              showSearch
              optionFilterProp="label"
              optionLabelProp="label"
              filterOption={(input, option) => {
                const label = option?.label?.toLowerCase() || "";
                return label.includes(input.toLowerCase());
              }}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              dropdownRender={(menu) => (
                <div>
                  {menu}
                  <div
                    style={{
                      padding: "8px",
                      borderTop: "1px solid var(--border-color)",
                    }}
                  >
                    <CustomButton
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={() => setAddPatientModalOpen(true)}
                      style={{ width: "100%", textAlign: "left" }}
                      size="small"
                    >
                      Create New Patient
                    </CustomButton>
                  </div>
                </div>
              )}
            >
              {patients?.map((patient) => {
                const mobileNumber = patient.mobile?.number
                  ? `${
                      patient.mobile.countryCode
                    } ${patient.mobile.number.replace(
                      /(\d{3})(\d{3})(\d{4})/,
                      "($1) $2-$3"
                    )}`
                  : "No mobile";
                return (
                  <Option
                    key={patient.id}
                    value={patient.id}
                    label={`${patient.name} - ${mobileNumber}`}
                    style={{borderBottom: "1px solid var(--border-color)"}}
                  >
                    {patient.name} : ({mobileNumber})
                  </Option>
                );
              })}
            </Select>
            {(!patients || patients?.length === 0) && (
              <div className="font-12 text-secondry mt-8">
                No patients available. Please add patients first.
              </div>
            )}
          </Col>
        )}

        {!patientEditable && selectedPatientForSchedule && (
          <div
            style={{
              background: "var(--secondary-bg)",
              border: "1px solid var(--border-color)",
              borderRadius: "8px",
              padding: "10px",
              marginBottom: "6px",
              margin: "0 10px",
              width: "100%",
            }}
          >
            <div style={{ marginBottom: "8px" }}>
              <span
                style={{ color: "#8A3EF4", fontWeight: 500, fontSize: "14px" }}
              >
                Selected Patients (
                {Array.isArray(selectedPatientForSchedule)
                  ? selectedPatientForSchedule.length
                  : 1}
                )
              </span>
            </div>
            {(Array.isArray(selectedPatientForSchedule)
              ? selectedPatientForSchedule
              : [selectedPatientForSchedule]
            ).map((patientId) => {
              const patient = patients?.find((p) => p.id === patientId);
              const mobileNumber = patient?.mobile?.number
                ? `${
                    patient.mobile.countryCode
                  } ${patient.mobile.number.replace(
                    /(\d{3})(\d{3})(\d{4})/,
                    "($1) $2-$3"
                  )}`
                : "No mobile";
              return (
                <div
                  key={patientId}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 0",
                    // borderBottom: '1px solid #e5e7eb',
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "var(--primary-text-color)",
                      }}
                    >
                      {patient?.name}
                    </div>
                    <div
                      style={{
                        color: "var(--secondary-text-color)",
                        fontSize: "14px",
                      }}
                    >
                      {mobileNumber}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {patientEditable ? (
          selectedVideoForSchedule &&
          (Array.isArray(selectedVideoForSchedule)
            ? selectedVideoForSchedule.length > 0
            : selectedVideoForSchedule) && (
            <Col span={24}>
              <div
                style={{
                  background: "var(--secondary-bg)",
                  border: "1px solid var(--border-color)",
                  borderRadius: "8px",
                  padding: "10px",
                  marginBottom: "6px",
                  margin: "0 10px",
                  width: "100%",
                }}
              >
                <div style={{ marginBottom: "8px" }}>
                  <span
                    style={{
                      color: "#8A3EF4",
                      fontWeight: 500,
                      fontSize: "14px",
                    }}
                  >
                    Selected Videos (
                    {Array.isArray(selectedVideoForSchedule)
                      ? selectedVideoForSchedule.length
                      : 1}
                    )
                  </span>
                </div>
                {(Array.isArray(selectedVideoForSchedule)
                  ? selectedVideoForSchedule
                  : [selectedVideoForSchedule]
                ).map((videoUrl) => {
                  const video = videos?.results?.find(
                    (v) => v.videoUrl === videoUrl
                  );
                  return (
                    <div
                      key={videoUrl}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 0",
                        // borderBottom: '1px solid #e5e7eb',
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "var(--secondary-bg)",
                          borderRadius: "6px",
                          padding: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: "32px",
                          height: "32px",
                          marginRight: "12px",
                        }}
                      >
                        <VideoCameraOutlined
                          style={{
                            fontSize: "14px",
                            color: "#8A3EF4",
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "16px",
                            color: "var(--primary-text-color)",
                          }}
                        >
                          {video?.title || "Unknown Video"}
                        </div>
                        {/* {video?.description && (
                          <div style={{ color: '#888', fontSize: '14px' }}>
                            {video.description}
                          </div>
                        )} */}
                        {video?.specialty && (
                          <div style={{ color: "#888", fontSize: "14px" }}>
                            {video.specialty}
                          </div>
                        )}
                        {video?.duration && (
                          <div
                            className="d-flex justify-start"
                            style={{
                              color: "#888",
                              fontSize: "12px",
                              gap: "3px",
                            }}
                          >
                            Duration: {video.duration}s
                            <ClockCircleOutlined />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Col>
          )
        ) : (
          <Col span={24}>
            <div
              className="font-medium mb-12"
              style={{ color: "var(--primary-text-color)" }}
            >
              Select Videos <span style={{ color: "#ff4d4f" }}>*</span>
            </div>
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              maxTagCount="responsive"
              placeholder="Choose videos to schedule"
              value={selectedVideoForSchedule || []}
              onChange={setSelectedVideoForSchedule}
              disabled={isLoading}
              size="large"
              showSearch
              optionFilterProp="label"
              optionLabelProp="label"
              filterOption={(input, option) => {
                const videoTitle = option?.label?.toLowerCase() || "";
                const videoTags = option?.tags?.toLowerCase() || "";
                const videospecialty = option?.specialty?.toLowerCase() || "";
                const videofilter =
                  option?.referenceMasterVideoId?.toLowerCase() || "";
                return (
                  videoTitle.includes(input.toLowerCase()) ||
                  videoTags.includes(input.toLowerCase()) ||
                  videospecialty.includes(input.toLowerCase()) ||
                  videofilter.includes(input.toLowerCase())
                );
              }}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              {videos?.results?.map((video) => (
                <Option
                  key={video.id}
                  value={video.videoUrl}
                  label={video.title} // Add label for search functionality
                  tags={video.tags?.join(", ")} // Add tags for search functionality
                  specialty={video.specialty}
                  referenceMasterVideoId={video.referenceMasterVideoId}
                  style={{borderBottom: "1px solid var(--border-color)"}}
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "12px", padding: "4px 0" }}
                  >
                    <div
                      style={{
                        backgroundColor: "var(--secondary-bg)",
                        borderRadius: "6px",
                        padding: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "32px",
                        height: "32px",
                      }}
                    >
                      <VideoCameraOutlined
                        style={{
                          fontSize: "14px",
                          color: "#8A3EF4",
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div
                        className="font-15 font-medium text-primary ellipsis"
                        style={{ lineHeight: "1.2", width: "50%" }}
                      >
                        {video.title}
                      </div>
                      {/* {video.description && ( */}
                      <div
                        className="text-secondry"
                        style={{
                          lineHeight: "1.2",
                          marginTop: "2px",
                          maxWidth: "300px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {video.specialty && (
                          <Tag>{capitalizeFirstLetter(video.specialty)}</Tag>
                        )}
                        <Tag
                          color={
                            !video?.generalLibrary
                              ? video.referenceMasterVideoId
                                ? "orange"
                                : "purple"
                              : "green"
                          }
                        >
                          {!video?.generalLibrary
                            ? video.referenceMasterVideoId
                              ? "AI Enhanced"
                              : "Master"
                            : "Patient Education"}
                        </Tag>
                      </div>
                      {/* )} */}
                      {video?.tags?.length > 0 &&
                        video?.tags.map((tag) => (
                          <div
                            key={tag}
                            className="font-12 text-secondry"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              lineHeight: "1.2",
                              marginTop: "2px",
                              maxWidth: "300px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {tag}
                          </div>
                        ))}
                    </div>
                    {video.duration && (
                      <div
                        className="d-flex text-secondry"
                        style={{ fontSize: "13px", gap: "3px" }}
                      >
                        {formatDuration(video.duration)}
                        <ClockCircleOutlined />
                      </div>
                    )}
                  </div>
                </Option>
              ))}
            </Select>
            {(!videos || videos?.results?.length === 0) && (
              <div className="font-12 text-secondry mt-8">
                No videos available. Please add videos first.
              </div>
            )}
          </Col>
        )}

        <Col span={24}>
          <div
            className="font-medium mb-12"
            style={{ color: "var(--primary-text-color)" }}
          >
            Notification Type <span style={{ color: "#ff4d4f" }}>*</span>
          </div>
          <Radio.Group
            value={notificationType}
            onChange={(e) => setNotificationType(e.target.value)}
            disabled={isLoading}
            size="large"
            style={{ display: "flex", gap: "24px" }}
          >
            <Radio value="both">Both (Email & SMS)</Radio>

            <Radio value="sms">TEXT/SMS</Radio>

            <Radio value="email">Email</Radio>
          </Radio.Group>
        </Col>

        <Col span={24}>
          <div
            className="font-medium mb-12 d-flex justify-start"
            style={{ color: "var(--primary-text-color)" }}
          >
            Surgery Date <span style={{ color: "#ff4d4f" }}>*</span>
            <span className="ml-5">
              ({userData?.timeZone ? userData?.timeZone : "America/New_York"})
            </span>
          </div>
          <DatePicker
            format="YYYY-MM-DD"
            placeholder="Select surgery date"
            style={{ width: "100%" }}
            size="large"
            value={scheduleDate}
            onChange={setScheduleDate}
            disabled={isLoading}
            disabledDate={(current) => {
              // Disable dates before today
              return current && current < moment().startOf("day");
            }}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          />
          <div className="font-12 text-secondry mt-8">
            <CalendarOutlined style={{ marginRight: "4px" }} />
            Email will be sent now. Reminders will be sent based on your
            selection.
          </div>
        </Col>

        <Col span={24}>
          <div
            className="mb-16"
            style={{ display: "flex", justifyContent: "start" }}
          >
            <div>
              <div
                className="font-medium"
                style={{ color: "var(--primary-text-color)" }}
              >
                Enable Reminder
              </div>
              <div className="font-12 text-secondry mt-4">
                Turn on to send emails at regular intervals
              </div>
            </div>
            <div>
              <Switch
                checked={enableFrequency}
                onChange={(checked) => {
                  setEnableFrequency(checked);
                  if (!checked) {
                    setScheduleFrequency("");
                    setRepeatUntil(null);
                  }
                }}
                disabled={isLoading}
                size="default"
              />
            </div>
          </div>
        </Col>

        {enableFrequency && (
          <>
            <Col span={12}>
              <div
                className="font-medium mb-12"
                style={{ color: "var(--primary-text-color)" }}
              >
                Frequency
              </div>

              <div style={{ display: "flex", gap: "12px", width: "100%" }}>
                <div style={{ flex: "1" }}>
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Select frequency"
                    value={scheduleFrequency}
                    onChange={(value) => {
                      setScheduleFrequency(value);
                      setIsCustomFrequency(value === "custom");
                      if (value === "custom") {
                        setCustomFrequencyNumber(1);
                      }
                    }}
                    disabled={isLoading}
                    // allowClear={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  >
                    <Option key="daily" value="daily">
                      Daily
                    </Option>
                    <Option key="weekly" value="weekly">
                      Weekly
                    </Option>
                    <Option key="monthly" value="monthly">
                      Monthly
                    </Option>
                    <Option key="custom" value="custom">
                      Custom
                    </Option>
                  </Select>
                </div>

                {isCustomFrequency && (
                  <div style={{ flex: "1" }}>
                    <Input
                      type="number"
                      min={1}
                      max={365}
                      value={customFrequencyNumber}
                      onChange={(e) => {
                        const value = parseInt(e.target.value) || 1;
                        setCustomFrequencyNumber(value);
                      }}
                      placeholder="Enter days"
                      disabled={isLoading}
                      size="large"
                      addonAfter="days"
                      style={{ width: "100%" }}
                    />
                  </div>
                )}
              </div>

              <div className="font-12 text-secondry mt-8">
                {isCustomFrequency
                  ? `Email will be sent every ${customFrequencyNumber} day${
                      customFrequencyNumber !== 1 ? "s" : ""
                    }`
                  : ""}
              </div>
            </Col>

            <Col span={12}>
              <div
                className="font-medium mb-12"
                style={{ color: "var(--primary-text-color)" }}
              >
                Repeat Until <span style={{ color: "#ff4d4f" }}>*</span>
              </div>
              <DatePicker
                format="YYYY-MM-DD"
                placeholder="Select end date for frequency"
                style={{ width: "100%" }}
                size="large"
                value={repeatUntil}
                onChange={setRepeatUntil}
                disabled={isLoading}
                disabledDate={(current) => {
                  return current && scheduleDate && current <= scheduleDate;
                }}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
              <div className="font-12 text-secondry mt-8">
                <CalendarOutlined style={{ marginRight: "4px" }} />
                Emails will be sent{" "}
                {scheduleFrequency === "custom"
                  ? `every ${customFrequencyNumber} day${
                      customFrequencyNumber !== 1 ? "s" : ""
                    }`
                  : scheduleFrequency}{" "}
                until this date
              </div>
            </Col>
          </>
        )}

        <Col span={24}>
          <div
            style={{
              backgroundColor: "var(--primary-bg)",
              border: "1px solid var(--border-color)",
              borderRadius: "8px",
              padding: "16px",
              marginTop: "8px",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{ gap: "8px", marginBottom: "-8px" }}
            >
              <div
                style={{
                  backgroundColor: "#e6f7ff",
                  borderRadius: "4px",
                  padding: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CalendarOutlined
                  style={{ fontSize: "12px", color: "#1890ff" }}
                />
              </div>
              <span className="font-13 font-medium text-primary">
                Schedule Summary
              </span>
            </div>
            <div className="font-12 text-secondry">
              {selectedVideoForSchedule &&
              (Array.isArray(selectedVideoForSchedule)
                ? selectedVideoForSchedule.length > 0
                : selectedVideoForSchedule) &&
              scheduleDate ? (
                <>
                  {selectedPatientForSchedule && (
                    <>
                      <div>
                        👥 Patients (
                        {Array.isArray(selectedPatientForSchedule)
                          ? selectedPatientForSchedule.length
                          : 1}
                        ):
                      </div>
                      <div
                        style={{
                          marginLeft: "16px",
                          marginTop: "4px",
                          marginBottom: "8px",
                        }}
                      >
                        {(Array.isArray(selectedPatientForSchedule)
                          ? selectedPatientForSchedule
                          : [selectedPatientForSchedule]
                        ).map((patientId) => {
                          const patient = patients?.find(
                            (p) => p.id === patientId
                          );
                          const mobileNumber = patient?.mobile?.number
                            ? `${
                                patient.mobile.countryCode
                              } ${patient.mobile.number.replace(
                                /(\d{3})(\d{3})(\d{4})/,
                                "($1) $2-$3"
                              )}`
                            : "No mobile";
                          return (
                            <div
                              key={patientId}
                              style={{ marginBottom: "4px" }}
                            >
                              • {patient?.name} ({mobileNumber})
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                  <div>
                    📹 Videos (
                    {Array.isArray(selectedVideoForSchedule)
                      ? selectedVideoForSchedule.length
                      : 1}
                    ):
                  </div>
                  <div style={{ marginLeft: "16px", marginTop: "4px" }}>
                    {(Array.isArray(selectedVideoForSchedule)
                      ? selectedVideoForSchedule
                      : [selectedVideoForSchedule]
                    ).map((videoUrl, index) => {
                      const video = videos?.results?.find(
                        (v) => v.videoUrl === videoUrl
                      );
                      return (
                        <div key={videoUrl} style={{ marginBottom: "4px" }}>
                          • {video?.title || "Unknown Video"}
                        </div>
                      );
                    })}
                  </div>
                  {notificationType && (
                    <div>
                      📧 Notification Type:{" "}
                      {notificationType === "email"
                        ? "Email"
                        : notificationType === "sms"
                        ? "SMS"
                        : "Both (Email & SMS)"}
                    </div>
                  )}
                  <div>
                    📅 {scheduleFrequency ? "First email" : "Scheduled for"}:{" "}
                    {scheduleDate.format("MMMM DD, YYYY")}
                  </div>
                  {enableFrequency && (
                    <>
                      <div>
                        🔄 Frequency:{" "}
                        {scheduleFrequency === "custom"
                          ? `Every ${customFrequencyNumber} day${
                              customFrequencyNumber !== 1 ? "s" : ""
                            }`
                          : scheduleFrequency}
                      </div>
                      {repeatUntil && (
                        <div>
                          ⏹️ Repeat until: {repeatUntil.format("MMMM DD, YYYY")}
                        </div>
                      )}
                    </>
                  )}
                  <div>
                    👤 Patients will receive the{" "}
                    {notificationType === "email"
                      ? "email"
                      : notificationType === "sms"
                      ? "SMS"
                      : "email and SMS"}{" "}
                    automatically
                  </div>
                </>
              ) : (
                "Please select videos and schedule date to see summary"
              )}
            </div>
          </div>
        </Col>

        <Col span={24} className="d-flex justify-end gap-12 mt-16">
          <CustomSecondaryButton
            onClick={handleModalClose}
            disabled={isLoading}
            size="large"
          >
            Cancel
          </CustomSecondaryButton>
          <CustomButton
            onClick={schedulePatientEmail}
            loading={isLoading}
            disabled={
              !selectedPatientForSchedule ||
              (Array.isArray(selectedPatientForSchedule) &&
                selectedPatientForSchedule.length === 0) ||
              !selectedVideoForSchedule ||
              (Array.isArray(selectedVideoForSchedule) &&
                selectedVideoForSchedule.length === 0) ||
              !scheduleDate ||
              !notificationType ||
              (scheduleFrequency && !repeatUntil)
            }
            size="large"
          >
            {isLoading ? "Scheduling..." : "Send Now"}
          </CustomButton>
        </Col>
      </Row>

      <AddPatientModal
        isOpen={addPatientModalOpen}
        setOpen={setAddPatientModalOpen}
        isEdit={false}
        fetchPatient={fetchPatient}
        physicianList={physicianList}
        userDetails={userDetails}
        onPatientCreated={handlePatientCreated}
      />
    </ModelWrapper>
  );
};

export default ScheduleEmailModal;
